import { render, staticRenderFns } from "./NewDatabaseDialog.vue?vue&type=template&id=35a79796"
import script from "./NewDatabaseDialog.vue?vue&type=script&lang=js"
export * from "./NewDatabaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports